export default {
  subscriptionHistory: 'Payment History',
};
